import Link from "next/link";

export default function ChangeEmail() {
  const dmAppUrl = !(typeof window === "undefined")
    ? /(localhost)|(staging)/.test(window.location.hostname)
      ? "https://staging.datamynt.com/app"
      : "https://datamynt.com/app"
    : "#";
  return (
    <p>
      Yes! Go to your profile settings by clicking on your name at the top right
      corner of the page and selecting “profile” and you’ll be redirected to
      your user panel or just use{" "}
      <Link href={dmAppUrl}>
        <a target="_blank" rel="noreferrer">
          this link
        </a>
      </Link>
      . There, select “Change email address” and follow the instructions.
    </p>
  );
}
